import { render } from "./Loading2.vue?vue&type=template&id=3e0d03ef&scoped=true"
import script from "./Loading2.vue?vue&type=script&lang=js"
export * from "./Loading2.vue?vue&type=script&lang=js"

import "./Loading2.vue?vue&type=style&index=0&id=3e0d03ef&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0d03ef"]])

export default __exports__